import React from 'react';
import CloseIcon from '../assets/icons/actions/CloseIcon';
import useTheme from '../hooks/ui/useTheme';
import CustomModal from '../components-library/CustomModal';
import { MODAL_SIZES } from '../services/exports/Constants';

interface Props {
  title: string;
  description: string;
  footer?: JSX.Element;
  openModal: boolean;
  toggleModal: () => void;
}

export default function AlertModal(props: Props) {
  const { title, description, footer, openModal, toggleModal } = props;

  const theme = useTheme();

  return (
    <CustomModal open={openModal} size={MODAL_SIZES.SM} onClose={toggleModal}>
      <div className={container}>
        <div className={wrapper}>
          {title && <h4 className={titleStyle}>{title}</h4>}
          {description && <p>{description}</p>}
          {footer && footer}
        </div>
        <div onClick={toggleModal} className="cursor-pointer">
          <CloseIcon className={closeIconStyle} color={theme?.color.brand.icon.color} />
        </div>
      </div>
    </CustomModal>
  );
}

const container = 'w-full h-full p-lg flex flex-row justify-between';

const wrapper = 'pr-md';

const titleStyle = 'mb-xs';

const closeIconStyle = 'h-4 w-4';
